import { InjectionToken } from '@angular/core'

/**
 * Ends the designer session, the way `ErrorInterceptor` does when it sees a 401.
 *
 * A token rather than `AuthConfigService` itself because the only callers that need it are
 * streams — the one kind of request `HttpClient`'s interceptor chain never sees — and a transport
 * should not have to depend on the auth module to say "this session is over". `app.config.ts`
 * binds it to `AuthConfigService.logout`, which is the single implementation.
 */
export const SESSION_LOGOUT = new InjectionToken<() => void>('SESSION_LOGOUT')
